





























import { Vue, Component, Prop } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import ExtensionCategoryListModel from '@/models/extension/extensionCategoryListModel'
import QuestionList from '@/components/lists/QuestionList.vue'
import AddDialog from '@/components/dialogs/AddDialog.vue'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule'
import ExtensionModule from '@/store/extensionModule'
import StageConstants from '@/constants/stageConstants'
import LoadingIndicator from '@/components/loading/LoadingIndicator.vue'
import ExtensionCategoryQuestionAnswerModel from '../models/extension/extensionCategoryQuestionAnswerModel'
import Validation from '@/mixins/validation'

const titleModule = getModule(TitleModule)
const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    QuestionList,
    AddDialog,
    LoadingIndicator
  }
})
export default class Stage extends Validation {
  @Prop(String) readonly stage!: string
  @Prop(String) readonly id!: string

  private stageKey: string = ''
  private dialog: boolean = false
  private categories: Array<ExtensionCategoryListModel> = []
  private loading: boolean = true
  private answer: ExtensionCategoryQuestionAnswerModel = new ExtensionCategoryQuestionAnswerModel()
  private listDisabled: boolean = false

  get formattedStage() {
    const stageName = this.stage.replace(/-/g, ' ')
    return stageName.charAt(0).toUpperCase() + stageName.slice(1)
  }

  private async created() {
    this.stageKey = StageConstants.getKeyByValue(this.stage)
    titleModule.setPageTitle(this.formattedStage)
    await this.getCategories()
  }

  private async getCategories(): Promise<void> {
    this.listDisabled = true

    try {
      this.categories = await ApiService.getQuestions<
        ExtensionCategoryListModel
      >(
        UrlType.ExtensionCategory,
        extensionModule.getExtensionId,
        this.stageKey,
        this.id + `?nocache=${new Date().getTime()}`
      )
    } finally {
      this.loading = false
      this.listDisabled = false
    }
  }

  private async editAnswerNotes(answerId: string): Promise<void> {
    this.answer = await ApiService.get(
      UrlType.ExtensionCategoryQuestionAnswer,
      answerId
    )

    this.dialog = true
  }

  private async saveAnswerNotes(valid: boolean): Promise<void> {
    if (valid) {
      await ApiService.put(
        UrlType.ExtensionCategoryQuestionAnswer,
        this.answer.extensionCategoryQuestionAnswerId,
        this.answer
      )

      this.dialog = false
    }
  }
}
